<template>
  <div class="fiatdeal-center">
    <div class="center-management-header a-3-bd clearfix">
      <c-navTab
        activeClassName="b-1-cl"
        activeColor="a-12-bg"
        className="b-2-cl"
        :currentTab="currentTab"
        :navTab="navTab"
        :lineHeight="lineHeight"
        :marginRight="marginRight"
        @currentType="currentType"
      />
    </div>
    <div class="center-management-center">
      <div class="center-main clearfix">
        <div class="center-main-select clearfix">
          <div class="selectArea">
            <div class="select">
              <!-- :promptText="$t('fiatdeal.center.country')" -->
              <c-select
                :value="value1"
                @onChanges="listChange"
                name="value1"
                :errorHave="true"
                :errorFlag="countryErrorFlag"
                errorText=""
                :options="list1"
                width="120px"
                newStyleFormat
                fill
                size="small"
              />
            </div>
            <div class="select">
              <!-- :promptText="$t('fiatdeal.center.payment')" -->
              <c-select
                :value="value3"
                @onChanges="listChange"
                name="value3"
                :errorHave="true"
                :errorFlag="countryErrorFlag"
                errorText=""
                :options="list3"
                width="120px"
                newStyleFormat
                fill
                size="small"
              />
            </div>
            <div class="select" v-if="paycoinsType === 1">
              <c-select
                :value="value2"
                @onChanges="listChange"
                name="value2"
                :errorHave="true"
                :errorFlag="countryErrorFlag"
                errorText=""
                :options="list2"
                width="120px"
                newStyleFormat
                fill
                size="small"
              />
            </div>
          </div>
          <div class="select-pay" v-if="paycoinsType === 2">
            <div class="input_line_content a-2-bd">
              <label class="input_line_prompt b-2-cl">{{ $t("fiatdeal.center.fiat") }}</label>
              <p class="payTypeList">
                <span
                  v-for="(v, key) in currencyListShow"
                  :key="key + 'currencyShow'"
                  @click="changKinde(v)"
                  class="u-11-cl"
                  :class="{ 'u-12-bg': value2 === v.code }"
                >
                  {{ v.value }}
                </span>
                <template v-for="(v, key) in currencyListHide">
                  <span
                    v-if="showMore"
                    @click="changKinde(v)"
                    class="u-11-cl"
                    :key="key + 'currencyHide'"
                    :class="{ 'u-12-bg': value2 === v.code }"
                  >
                    {{ v.value }}
                  </span>
                </template>
                <span @click="showKinde()" class="u-8-cl">
                  {{ openOTxt }}
                </span>
              </p>
            </div>
          </div>
          <!-- 信用卡交易 -->
          <!-- <p class="fiatdeal-xyk">
            <img src="https://saas-oss.oss-accelerate.aliyuncs.com/upload/20200429141529768.svg" />
            <img src="https://saas-oss.oss-accelerate.aliyuncs.com/upload/20200429142925574.svg" />
            <span class="x-3-cl" @click="handlerGoCredit">{{ $t("creditCard.title") }}</span>
          </p> -->
        </div>
        <c-table
          :imgMap="imgMap"
          :colorMap="colorMap"
          :classes="classes"
          :loading="loading"
          :headClasses="headClasses"
          :bodyClasses="bodyClasses"
          :lineClasses="lineClass"
          :columns="columns"
          :dataList="dataList"
          :lineNumber="lineNumber"
          :cellHeight="cellHeight"
          @elementClick="operation"
        />
        <c-pagination
          v-show="count > 15"
          :total="count"
          :current-page="page"
          :display="pageSize"
          class="a-5-bg"
          @pagechange="pagechange"
        >
        </c-pagination>
      </div>
    </div>
    <!-- 提示框 -->
    <c-alert
      :showFlag="alertFlag"
      :buttonText="this.$t('personal.alert.buttonOpen')"
      :imgMap="imgMap"
      :colorMap="colorMap"
      @close="alertClose"
      @confirm="alertGo"
    >
      <div class="alertText">{{ tradeTypeErrorText }}</div>
    </c-alert>
  </div>
</template>

<script>
import {
  fixD, nul, colorMap, imgMap, getCoinShowName,
} from '@/utils';

export default {
  name: 'center',
  filters: {
    roseFilter(v) {
      return fixD(v, 2);
    },
  },
  data() {
    return {
      paramsConfig: {
        ordinary: {
          side: 'SELL',
          isBlockTrade: 0,
        },
        ordinaryBuy: {
          side: 'SELL',
          isBlockTrade: 0,
        },
        ordinarySell: {
          side: 'BUY',
          isBlockTrade: 0,
        },
        bulk: {
          side: 'SELL',
          isBlockTrade: 1,
        },
        bulkBuy: {
          side: 'SELL',
          isBlockTrade: 1,
        },
        bulkSell: {
          side: 'BUY',
          isBlockTrade: 1,
        },
      },
      // alert弹框
      alertFlag: false,
      imgMap,
      colorMap,
      paymentList: [], // 支付方式list
      // table loading
      loading: false,
      // 分钟线
      klineDataList: [],
      lastPrice: '', // 最新价
      avgPrice: '', // 平均价
      rose: '', // 涨跌幅
      roseColor: 0, // 0 无颜色 1 涨绿 2 跌红
      side: '', // 买卖
      // 是否是大宗交易
      isBlockTrade: 0,
      defaultCoin: '', // 交易币种
      otcDefaultPaycoin: '', // 交易法币
      // 横向导航参数
      currentTab: 1,
      navTab: [],
      lineHeight: '55',
      marginRight: 48, // 距离右边的距离
      // select相关
      value1: '', // 国家
      value2: '', // 法币
      value3: '', // 支付方式
      countryErrorFlag: false,
      list1: [],
      list2: [],
      currencyListShow: [],
      currencyListHide: [],
      showMore: false,
      openC: 0,
      paycoinsType: 0,
      list3: [],
      // 法币币种
      paycoins: [],
      // table 相关
      columns: [
        // 商家
        {
          title: this.$t('fiatdeal.center.columns')[0],
          // align: 'left',
          width: '200px',
          classes: '',
        },
        // 数量
        {
          title: this.$t('fiatdeal.center.columns')[1],
          // align: 'right',
          width: '200px',
          classes: '',
        },
        // 限额
        {
          title: this.$t('fiatdeal.center.columns')[2],
          // align: 'right',
          width: '200px',
          classes: '',
        },
        // 单价
        {
          title: this.$t('fiatdeal.center.columns')[3],
          // align: 'right',
          width: '190px',
          classes: '',
        },
        // 支付方式
        {
          title: this.$t('fiatdeal.center.columns')[4],
          // align: 'right',
          width: '150px',
          classes: '',
        },
        // 操作
        {
          title: this.$t('fiatdeal.center.columns')[5],
          // align: 'right',
          width: '120px',
          classes: '',
        },
      ],
      dataList: [],
      cellHeight: 70,
      headHeight: 30,
      lineNumber: 15,
      classes: '',
      headClasses: '',
      bodyClasses: '',
      lineClass: '',
      // page相关
      count: 0,
      page: 1,
      pageSize: 15,
      tradeTypeErrorShop: [],
    };
  },
  computed: {
    currentConfig() {
      return this.paramsConfig[this.$route.params.pageType];
    },
    isLogin() {
      return this.$store.state.baseData.isLogin;
    },
    tradeTypeErrorText() {
      const start = this.$t('personal.alert.payTypeError[0]');
      const end = this.$t('personal.alert.payTypeError[1]');
      let pay = '';
      this.tradeTypeErrorShop.forEach((el) => {
        pay += `${el.title},`;
      });
      pay = pay.substr(0, pay.length - 1);

      return `${start}${pay}${end}`;
    },
    market() {
      return this.$store.state.baseData.market;
    },
    priceFix() {
      let fix = this.$store.state.baseData.defaultFiatPrecision;
      if (
        this.market
        && this.market.coinList[this.defaultCoin]
        && this.market.coinList[this.defaultCoin].fiatPrecision
        && this.market.coinList[this.defaultCoin].fiatPrecision[this.value2.toLowerCase()]
      ) {
        fix = this.market.coinList[this.defaultCoin].fiatPrecision[this.value2.toLowerCase()];
      }
      return Number(fix);
    },
    otcPaymentFind() {
      return this.$store.state.personal.otcPaymentFind;
    },
    openOTxt() {
      return this.$t('fiatdeal.openA')[this.openC];
    },
    userInfo() {
      return this.$store.state.baseData.userInfo;
    },
    otcSearch() {
      return this.$store.state.fiatdeal.otcSearch;
    },
    sideIsBlockTrade() {
      return this.$store.state.fiatdeal.sideIsBlockTrade;
    },
    otcTicker() {
      return this.$store.state.fiatdeal.otcTicker;
    },
    otcMinuteLine() {
      return this.$store.state.fiatdeal.otcMinuteLine;
    },
    publicInfo() {
      return this.$store.state.baseData.publicInfo;
    },
    otcPublicInfo() {
      return this.$store.state.baseData.otcPublicInfo;
    },
  },
  watch: {
    otcPaymentFind(otcPaymentFind) {
      if (otcPaymentFind) {
        this.paymentList = otcPaymentFind.data;
      }
    },
    defaultCountryCode(v) {
      if (v && this.value1 === '') {
        this.value1 = v;
      }
    },
    '$route.params.pageType'() {
      this.getList();
    },
    otcTicker(otcTicker) {
      // 头部数据
      if (otcTicker) {
        if (this.publicInfo) {
          if (this.otcPublicInfo) {
            this.lastPrice = this.dealOtcTicke(otcTicker.data.lastPrice);
            this.avgPrice = this.dealOtcTicke(otcTicker.data.avgPrice);
            this.rose = otcTicker.data.rose;
            this.roseData(this.rose);
          }
        }
      }
    },
    otcMinuteLine(otcMinuteLine) {
      if (otcMinuteLine !== null) {
        // 数据处理kline
        this.kLineData(otcMinuteLine.data);
      }
    },
    publicInfo(publicInfo) {
      if (publicInfo) {
        if (this.otcPublicInfo) {
          // 数据处理 显示头部横向列表
          this.dataProcessin(publicInfo.market.coinList, this.otcPublicInfo.defaultCoin);
          if (!this.defaultCoin) {
            this.defaultCoin = this.otcPublicInfo.defaultCoin;
          }
          this.side = this.otcPublicInfo.defaultSeach.toUpperCase();
          this.otcDefaultPaycoin = this.otcPublicInfo.otcDefaultPaycoin;
          this.value2 = this.otcPublicInfo.otcDefaultPaycoin;

          // 国家地区数据处理
          this.dataCountry(this.otcPublicInfo.countryNumberInfo);
          // 处理法币币种数据
          this.dataPaycoins(this.otcPublicInfo.paycoins);
          // 支付方式数据处理
          this.dataPayments(this.otcPublicInfo.payments);
          // 请求数据
          // 搜索数据
          this.getList();
          // 24小时数据
          this.getOtcTicke();
          // 分钟线
          this.getMinuteLine();
          // 头部数据
          if (this.otcTicker) {
            this.lastPrice = this.dealOtcTicke(this.otcTicker.data.lastPrice);
            this.avgPrice = this.dealOtcTicke(this.otcTicker.data.avgPrice);
            this.rose = this.otcTicker.data.rose;
          }
        }
      }
    },
    otcPublicInfo(otcPublicInfo) {
      if (otcPublicInfo) {
        if (this.publicInfo) {
          // 数据处理 显示头部横向列表
          this.dataProcessin(this.publicInfo.market.coinList, otcPublicInfo.defaultCoin);
          if (!this.defaultCoin) {
            this.defaultCoin = otcPublicInfo.defaultCoin;
          }
          this.side = otcPublicInfo.defaultSeach.toUpperCase();
          this.otcDefaultPaycoin = otcPublicInfo.otcDefaultPaycoin;
          this.value2 = otcPublicInfo.otcDefaultPaycoin;

          // 国家地区数据处理
          this.dataCountry(otcPublicInfo.countryNumberInfo);
          // 处理法币币种数据
          this.dataPaycoins(otcPublicInfo.paycoins);
          // 支付方式数据处理
          this.dataPayments(otcPublicInfo.payments);
          // 请求数据
          // 搜索数据
          this.getList();
          // 24小时数据
          this.getOtcTicke();
          // 分钟线
          this.getMinuteLine();
          // 头部数据
          if (this.otcTicker) {
            this.lastPrice = this.dealOtcTicke(this.otcTicker.data.lastPrice);
            this.avgPrice = this.dealOtcTicke(this.otcTicker.data.avgPrice);
            this.rose = this.otcTicker.data.rose;
          }
        }
      }
    },
  },
  mounted() {
    this.init();
    this.getList();
  },
  methods: {
    init() {
      this.$store.dispatch('otcPaymentFind'); // 获取支付方式list
      if (this.defaultCountryCode) {
        this.value1 = this.defaultCountryCode;
      }
      const { otcPublicInfo } = this.$store.state.baseData;
      const { publicInfo } = this.$store.state.baseData;
      const { userInfo } = this.$store.state.baseData;
      if (otcPublicInfo && publicInfo) {
        // 数据处理 显示头部横向列表
        this.dataProcessin(publicInfo.market.coinList, otcPublicInfo.defaultCoin);
        // 头部单位
        if (!this.defaultCoin) {
          this.defaultCoin = otcPublicInfo.defaultCoin;
        }
        this.side = otcPublicInfo.defaultSeach.toUpperCase();
        this.otcDefaultPaycoin = otcPublicInfo.otcDefaultPaycoin;
        this.value2 = otcPublicInfo.otcDefaultPaycoin;

        // 国家地区数据处理
        this.dataCountry(otcPublicInfo.countryNumberInfo);
        // 处理法币币种数据
        this.dataPaycoins(otcPublicInfo.paycoins);
        // 支付方式数据处理
        this.dataPayments(otcPublicInfo.payments);
        // 请求数据
        // 搜索数据
        this.getList();
        // 24小时数据
        this.getOtcTicke();
        // 分钟线
        this.getMinuteLine();
        // 分钟线轮训
        setInterval(() => {
          // 分钟线
          this.getMinuteLine(true);
        }, 30000);
      }
      if (userInfo !== null) {
        if (userInfo.nickName && userInfo.isCapitalPwordSet) {
          if (!userInfo.isOpenMobileCheck && !userInfo.googleStatus) {
            this.$bus.$emit('tip', { text: this.$t('fiatdeal.center.idinfo'), type: 'info' });
          }
        } else {
          this.$bus.$emit('tip', { text: this.$t('fiatdeal.center.idinfo'), type: 'info' });
        }
      }
    },
    changKinde(v) {
      this.value2 = v.code;
      this.otcDefaultPaycoin = v.code;
      this.listChange(v, 'value2');
    },
    showKinde() {
      this.showMore = !this.showMore;
      if (this.openC === 0) {
        this.openC = 1;
      } else {
        this.openC = 0;
      }
    },
    roseData(rose) {
      if (rose === 0) {
        this.roseColor = 0;
      } else if (rose > 0) {
        this.roseColor = 1;
      } else {
        this.roseColor = 2;
      }
    },
    alertClose() {
      this.alertFlag = false;
    },
    alertGo() {
      this.alertFlag = false;
      this.$router.push('/personal/leaglTenderSet');
    },
    dealOtcTicke(price) {
      return fixD(price, this.priceFix);
    },
    kLineData(data) {
      const list = [];
      data.forEach((obj) => {
        list.push([obj.time, obj.price]);
      });
      this.klineDataList = list;
    },
    operation(type, id) {
      if (!this.isLogin) {
        this.$router.push('/login');
        return;
      }

      switch (type) {
        case 'icon':
          this.$router.push({ path: '/stranger', query: { uid: id[0] } });
          break;
        default:
          if (this.side === 'BUY' && !this.isPaymentMatch(id[2])) {
            // 要出售时并无支付方式时
            [, , this.tradeTypeErrorShop] = id;
            this.alertFlag = true;
          } else {
            this.$router.push({ path: '/otcTrade?', query: { orderId: id[1], userId: id[0] } });
          }
      }
    },
    isPaymentMatch(payments) {
      if (this.paymentList.length === 0) {
        // 如果用户没有任何支付方式设定，则不能进行交易
        return false;
      }
      if (!payments || payments.length === 0) {
        // 如果商户没有支付方式，则不能进行交易
        return false;
      }

      // 检查支付方式是否匹配
      return payments.some(obj => this.paymentList.some(payment => obj.key === payment.payment));
    },
    pagechange(data) {
      this.page = data;
      this.getList();
    },
    getList() {
      if (this.loading || !this.value2 || !this.defaultCoin) {
        return;
      }
      const info = {
        side: this.currentConfig.side,
        symbol: this.defaultCoin,
        isBlockTrade: this.currentConfig.isBlockTrade,
        payCoin: this.value2,
        payments: this.value3 === 'all' ? '' : this.value3,
        numberCode: this.value1 === 'all' ? '' : this.value1,
        pageSize: this.pageSize,
        page: this.page,
      };
      this.loading = true;
      this.axios({
        url: 'otc/search',
        method: 'post',
        params: info,
        hostType: 'otc',
      }).then((res) => {
        this.loading = false;
        if (res.code === 0) {
          const resData = res.data || {};
          this.count = resData.count;
          this.tablesData(resData.advertList);
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    getOtcTicke() {
      const info = {
        symbol: this.defaultCoin,
        payCoin: this.value2,
      };
      this.$store.dispatch('otcTicker', info);
    },
    getMinuteLine(auto) {
      const info = {
        symbol: this.defaultCoin,
        payCoin: this.value2,
      };
      if (auto) {
        info.auto = true;
      }
      this.$store.dispatch('otcMinuteLine', info);
    },
    tablesData(data) {
      // 处理数据
      const { coinList } = this.$store.state.baseData.market;
      const list = [];
      if (data) {
        data.forEach((obj) => {
          list.push({
            id: [obj.userId, obj.advertId, obj.payments],
            data: [
              [
                // 商家
                {
                  type: 'icon',
                  eventType: 'icon',
                  iconSvg: `<div class="merchants">
                    <div class="merchants-left a-12-bg" style="color:#EDF4F8">
                    ${obj.imageUrl ? `<img src="${obj.imageUrl}"/>` : `<span>${obj.otcNickName.substring(0, 1)}</span>`}
                    <i class="i a-5-bd ${obj.loginStatus === 1 ? 'a-18-bg' : 'a-1-bg'}"></i>
                    </div>
                    <div class="merchants-right">
                    <p>${obj.otcNickName}</p>
                    <p>
                      <span>${this.$t('fiatdeal.center.trading')} ${obj.completeOrders}</span>
                      <span>|</span>
                      <span class="green-cl">${this.$t('fiatdeal.center.credit')} ${nul(obj.creditGrade, 100)}%</span></p>
                    </div>
                    </div>`,
                },
              ],
              [
                // 数量
                {
                  text: `${fixD(obj.volumeBalance, coinList[this.defaultCoin].showPrecision)}
                    ${getCoinShowName(this.defaultCoin, this.market.coinList)}`,
                  classes: '',
                },
              ],
              [
                // 限额
                {
                  text: `${fixD(obj.minTrade, this.priceFix)}
                  - ${fixD(obj.maxTrade, this.priceFix)} ${obj.payCoin}`,
                  classes: '',
                },
              ],
              [
                // 单价
                {
                  text: `${fixD(obj.price, this.priceFix)} ${obj.payCoin}`,
                  classes: '',
                },
              ],
              [
                // 支付方式
                ...this.getPaymentsListObj(obj.payments),
                // {
                //   type: 'icon',
                //   iconSvg: `<ul>${this.paymentsList(obj.payments).join('')}</ul>`,
                //   svgIconClass:
                //   classes: 'payments-ul',
                // },
              ],
              [
                // 操作
                {
                  type: 'button', // 'link' ' button' ,'html', 'label', 'icon' ‘str’
                  attrs: {
                    type: 'solid',
                    height: '32px',
                  },
                  text:
                    this.currentConfig.side === 'SELL'
                      ? this.$t('fiatdeal.center.buy')
                      : this.$t('fiatdeal.center.sell'),
                  iconClass: [''],
                  eventType: 'check',
                  classes: [],
                },
              ],
            ],
          });
        });
        this.dataList = list;
      } else {
        this.dataList = [];
      }
    },
    paymentsList(data) {
      const list = [];
      data.forEach((obj) => {
        list.push(`<li><img src=${obj.icon} /></li>`);
      });
      return list;
    },
    getIconClassName(key) {
      const iconMap = {
        'otc.payment.alipay': 'icon-ali',
        'otc.payment.wxpay': 'icon-wechat',
        'otc.payment.domestic.bank.transfer': 'icon-bank',
      };
      return iconMap[key];
    },
    getPaymentsListObj(payments) {
      const list = [];
      payments.forEach((payment) => {
        if (this.getIconClassName(payment.key)) {
          list.push({
            type: 'icon',
            svgIconClass: this.getIconClassName(payment.key),
            classes: 'payments-icon',
          });
        }
      });
      return list;
    },
    listChange(item, name) {
      // debugger
      switch (name) {
        case 'value1':
          this.value1 = item.code;
          // 24小时数据
          this.getOtcTicke();
          // 分钟线
          this.getMinuteLine();
          break;
        case 'value2':
          this.value2 = item.code;
          this.otcDefaultPaycoin = item.code;
          // 24小时数据
          this.getOtcTicke();
          // 分钟线
          this.getMinuteLine();
          break;
        default:
          this.value3 = item.code;
      }
      // 重新请求table数据
      // 数据重置
      this.page = 1;
      this.pageSize = 15;
      this.getList();
    },
    currentType(data) {
      this.currentTab = data.index;
      this.defaultCoin = data.coinName;
      // 重新请求table数据
      // 数据重置
      this.page = 1;
      this.pageSize = 15;
      this.getList();
      // 24小时数据
      this.getOtcTicke();
      // 分钟线
      this.getMinuteLine();
    },


    /**
     * 数据处理 显示头部横向列表
     */
    dataProcessin(data, symbol) {
      let list = Object.values(data);

      if (Array.isArray(list)) {
        list = list.sort((a, b) => a.sort - b.sort);
      }

      this.navTab = [];
      let tab = false;
      let count = 0;
      list.forEach((obj) => {
        if (Number(obj.otcOpen) === 1) {
          count += 1;
          this.navTab.push({
            name: getCoinShowName(obj.name, this.market.coinList),
            index: count,
            coinName: obj.name,
          });
          if (obj.name === symbol) {
            this.currentTab = count;
            tab = true;
          }
        }
      });
      if (!tab) {
        this.currentTab = this.navTab[0].index;
        this.defaultCoin = this.navTab[0].name;
        // this.getOtcTicke();
      }
    },

    /**
     * 处理法币币种数据
     */
    dataPaycoins(data) {
      this.paycoinsType = 1;
      this.currencyListHide = [];
      this.currencyListShow = [];
      data.forEach((obj) => {
        if (obj.used) {
          const object = { value: obj.title, code: obj.key };
          if (obj.hide) {
            this.paycoinsType = 2;
            object.hide = 1;
            this.currencyListHide.push(object);
          } else {
            this.currencyListShow.push(object);
          }
          this.list2.push(object);
        }
      });
    },

    /**
     * 支付方式数据处理
     */
    dataPayments(data) {
      const List = [];
      List.push({ value: this.$t('fiatdeal.center.all'), code: 'all' });
      data.forEach(obj => List.push({ value: obj.title, code: obj.key }));
      this.list3 = List;
      this.value3 = 'all';
    },

    /**
     * 国家地区数据处理
     */
    dataCountry(data) {
      const List = [];
      List.push({ value: this.$t('fiatdeal.center.all'), code: 'all' });
      data.forEach(obj => List.push({ value: obj.title, code: obj.numberCode }));
      this.list1 = List;
      this.value1 = 'all';
    },

    /**
     * 跳转到信用卡页面
     * 废弃,目前没有逻辑
     */
    handlerGoCredit() {
      this.$router.push('/creditCard');
    },
  },
};
</script>
<style lang="scss">
.fiatdeal-center {
  width: 100%;
  font-family: Medium;

  .alertText {
    line-height: 18px;
  }
  .center-management-header {
    font-size: 14px;
    position: relative;
    float: left;
    width: 100%;
    padding-left: 20px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    box-sizing: border-box;
  }
  .center-management-center {
    .center-header {
      width: 940px;
      float: left;
      padding: 40px 20px 0 20px;
      border-bottom-style: solid;
      border-bottom-width: 1px;
      .center-header-left {
        float: left;
        margin-bottom: 32px;
        .title {
          font-size: 14px;
        }
        .data-main {
          margin: 10px 0;
          font-size: 22px;
          span {
            font-size: 14px;
          }
        }
        .text {
          font-size: 14px;
        }
      }
      .center-header-right {
        float: right;
        width: 420px;
        height: 94px;
        position: relative;
        bottom: -6px;
        -moz-bottom: -6px;
      }
    }
    .center-main {
      float: left;
      width: 100%;
      .center-main-select {
        display: flex;
        justify-content: space-between;
        padding: 24px;

        .selectArea {
          flex: 1;
          display: flex;
          align-items: center;
          gap: 16px;
        }
      }
      .table-body td .icon-btn {
        margin-left: 0;
      }
    }
  }
  .merchants {
    width: 200px;
    display: flex;
    .merchants-left {
      flex-shrink: 0;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      position: relative;
      margin-right: 10px;
      margin-top: 2px;
      span {
        position: absolute;
        width: 30px;
        height: 30px;
        top: 0;
        left: 0;
        z-index: 2;
        line-height: 30px;
        text-align: center;
      }
      img {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        position: absolute;
        top: 0;
        left: 0;
      }
      i.i {
        width: 6px;
        height: 6px;
        position: absolute;
        border-radius: 50%;
        border-style: solid;
        border-width: 1px;
        z-index: 2;
        right: 0;
        bottom: 0;
      }
    }
    .merchants-right {
      font-size: 14px;
      p {
        line-height: 16px;
      }
      p:nth-of-type(2) {
        font-size: 12px;
        margin-top: 5px;
      }
    }
  }
  .payments-icon {
    font-size: 20px;
    display: inline;
    margin-right: 20px;
    &:last-child {
      margin-right: 0;
    }
  }
  .table-head {
    padding: 0;
    // margin: 0 20px;
  }
  .select-pay {
    width: 680px !important;
    font-size: 12px !important;
  }
  .payTypeList {
    padding-top: 10px;
  }
  .payTypeList span {
    display: inline-block;
    height: 24px;
    line-height: 24px;
    cursor: pointer;
    margin-bottom: 10px;
    width: 110px;
    overflow: hidden;
    text-align: center;
  }
}
.fiatdeal-center .fiatdeal-xyk {
  display: flex;
  align-items: center;
  gap: 5px;

  img {
    vertical-align: middle;
  }
  .x-3-cl {
    color: rgba(36, 160, 245, 1) !important;
    cursor: pointer;
  }
}
</style>
